import React from 'react'
import format from 'civic-champs-shared/utils/format'
import { Row } from 'react-table'
import { ExportButton } from 'core/table/components'

const filename = 'members.csv'

const headers = [
  { label: 'First Name', key: 'firstName' },
  { label: 'Last Name', key: 'lastName' },
  { label: 'Email', key: 'email' },
  { label: 'Mobile Phone', key: 'phoneNumber' },
  { label: 'Home Phone', key: 'homePhoneNumber' },
  { label: 'Groups', key: 'groups' },
  { label: 'Hours', key: 'hours' },
  { label: 'Invited On', key: 'invitedOn' },
  { label: 'Tags', key: 'tags' },
  { label: 'Status', key: 'status' },
]

const formatData = (rows: Row<any>[]) =>
  rows.map(({ original: value }) => ({
    firstName: value.person.givenName,
    lastName: value.person.familyName,
    email: value.person.email,
    phoneNumber: format.phoneNumber(value.person.phoneNumber),
    homePhoneNumber: format.phoneNumber(value.person.homePhoneNumber),
    groups: value.groups || '',
    hours: format.fixedPoint(value.totalVolunteerHours, 1),
    invitedOn: format.date(value.createdAt),
    tags: (value.tags || []).map((tag: { name: string }) => tag.name).join(', '),
    status: value.status.displayName,
  }))

const ExportGroupMembersMenuButton = ({ data, disabled }: { data: Row<any>[]; disabled?: boolean }) => (
  <ExportButton data={data} formatData={formatData} headers={headers} disabled={disabled} filename={filename} />
)

export default ExportGroupMembersMenuButton
